import { PAYEX_PLATFORM } from 'constants/ui';
import { useSelector } from 'react-redux';
import type { RootState } from 'reducers/types';
import { getRecipientId } from 'selectors/entities/recipient/recipient';
import { getCurrentCountryCode, getPlatform } from 'selectors/ui/ui';
import { useExperimentFlag } from './useExperiments/useExperimentFlag';

export const useIsOtpEnabled = (flagName: string): boolean => {
  const platform = useSelector(getPlatform);
  const recipientId = useSelector(getRecipientId);
  const countryFrom = useSelector(getCurrentCountryCode) as string;
  const countryTo = useSelector(
    (state: RootState) => state.entities?.recipient?.country,
  );

  const { value: isOtpEnabled } = useExperimentFlag({
    flagName,
    userContext: {
      platform,
      ...(recipientId && { portal_code: recipientId }),
      ...(countryFrom && { country_from: countryFrom }),
      ...(countryTo && { country_to: countryTo }),
    },
  });

  if (platform !== PAYEX_PLATFORM) {
    return false;
  }

  return isOtpEnabled;
};
